<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },
  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Object, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
  },
  data() {
    return {
      buttonAns: _.cloneDeep(this.selected),
    }
  },
  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.buttonAns = []
      }
    },

    buttonAns(newValue) {
      if (newValue.length) {
        const val = this.questionOptions[newValue]
        this.$emit('update', Object.fromEntries([[newValue, val]]))
      }
    },
  },
}
</script>

<template id="buttonwrapp">
  <div :class="$style.buttonWrapp">
    <h3 :class="$style.question">{{ questionTitle }}<sup>*</sup></h3>
    <ul :class="$style.questionOptionList">
      <li v-for="(options, key) in questionOptions" :key="key">
        <v-radio-group v-model="buttonAns" :class="$style.listclss">
          <v-radio :label="options" :value="key"></v-radio>
        </v-radio-group>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.question {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
}
.question sup {
  color: #f00;
}
.questionOptionList {
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  float: left;
  margin-right: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #09101d;
}
.questionOptionList li:last-child {
  margin-right: 0;
}
@media screen and (max-width: 479px) {
  .questionOptionList {
    display: flex;
    margin-left: 0;
  }
  .questionOptionList li {
    flex: 50%;
  }
}
</style>

<style scoped>
.v-radio.v-item--active {
  display: inline-block;
  width: 120px;
  padding: 12px;
  text-align: center;
  background: #0476d9;
  border: 2px solid #0476d9 !important;
  border-radius: 5px;
}
.v-radio {
  display: inline-block;
  width: 120px;
  padding: 12px;
  text-align: center;
  background: #fff;
  border: 2px solid #0476d9 !important;
  border-radius: 5px;
}

/deep/ .v-input--selection-controls__input .v-icon {
  display: none !important;
}
/deep/ .v-input--selection-controls__input {
  width: 0 !important;
  height: 0 !important;
}
/deep/ .v-input .v-label {
  position: relative !important;
  right: auto;
  left: -6px !important;
  font-weight: 600;
  color: #0476d9 !important;
}
/deep/ .v-radio.v-item--active .v-label {
  color: #fff !important;
}
/deep/
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple::before {
  background: inherit !important;
  -webkit-transition: none;
  transition: none;
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}
@media screen and (max-width: 479px) {
  .v-radio.v-item--active,
  .v-radio {
    width: 100%;
  }
}
</style>
